<template>
  <div class="file-upload">
    <el-input
        v-model="filePath"
        placeholder="选择文件或文件夹"
        class="input-file-path"
        readonly
    >
      <template #prepend>
        <!-- 点击时触发文件或文件夹选择 -->
        <el-button @click="triggerFileSelect">点击选择</el-button>
      </template>
    </el-input>


    <div class="drag-upload-area-container">
      <div
          class="drag-upload-area"
          @dragover.prevent
          @drop.prevent="handleDrop"
          @click="triggerFileSelect"
      >
        <div class="el-upload__text">点击选择文件夹</div>

        <div class="el-upload__tip">请上传文件夹，大小在50M以内</div>
      </div>
    </div>


    <el-button class="start-parse-btn" @click="unCompressPackage">
      开始解压压缩包
    </el-button>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";

export default {
  name: "FileUpload",
  data() {
    return {
      filePath: "", // 用于展示文件或文件夹的路径
      fileObject: null, // 存储选择的文件或文件夹对象
    };
  },
  methods: {

//     点击时触发文件或文件夹选择对话框
    async triggerFileSelect() {
      const filePathList = await window.electronAPI.selectFile("file", [
        {name: "Compressed Files", extensions: ["zip", "rar", "7z", "tar", "gz"]},
      ]);
      if (filePathList[0]) {
        let pkgPath = filePathList[0]
        this.filePath = pkgPath; // 设置文件路径
        console.log("选中的文件或文件夹路径:", pkgPath);
      } else {
        // 这种情况是用于点击取消
        // ElMessage.error(`文件夹路径${filePath} 获取信息出错，联系TLS技术人员 `);
      }
    },

    // 处理文件或文件夹拖拽操作
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        const file = files[0];
        this.filePath = file.path; // 获取文件的绝对路径
        console.log("拖拽的文件路径:", file.path);
      }
    },

    // 开始AI解析的逻辑
    async unCompressPackage() {
      if (this.filePath) {
        console.log("开始解析，压缩包文件路径:", this.filePath);
        try {
          const result = await window.electronAPI.uncompress(this.filePath);
          console.log("结果儿", result);
          ElMessage.success("解压完成！"); // 解压成功后显示弹窗
        } catch (err) {
          console.error("解压失败:", err);
          ElMessage.error(`解压失败: ${err.message}`); // 错误时显示错误信息
        }
      } else {
        ElMessage.warning("未选择文件或文件夹"); // 未选择文件时提示
      }
    }
  },
};
</script>

<style scoped>

.file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.input-file-path {
  width: 100%;
  max-width: 800px;
  margin: 40px;
}

.drag-upload-area-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: white;
  height: 300px; /* 根据需要调整高度 */
  text-align: center;
}

/* 模拟拖拽上传的样式 */
.drag-upload-area {
  border: 2px dashed #d9d9d9;
  padding: 50px;
  background-color: #f5f7fa;
  width: 30%;
  max-width: 800px;
  cursor: pointer;
  position: relative;
}

.drag-upload-area:hover {
  background-color: #eef2f7;
}

.start-parse-btn {
  margin: 50px;
  width: 300px;
}

</style>
